export default {
  UPDATE_FUTURE: 'UPDATE_FUTURE',
  SET_SINGLE_BET_INPUT_VALUE: 'SET_SINGLE_BET_INPUT_VALUE',
};
